import { render, staticRenderFns } from "./InfoNew.vue?vue&type=template&id=949ecb0e&scoped=true&"
import script from "./InfoNew.vue?vue&type=script&lang=js&"
export * from "./InfoNew.vue?vue&type=script&lang=js&"
import style0 from "./InfoNew.vue?vue&type=style&index=0&id=949ecb0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949ecb0e",
  null
  
)

export default component.exports